import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  message: string | null;
}

/**
 * Faengt Render- und Effekt-Fehler ab.
 *
 * Ohne Boundary raeumt React bei einem unbehandelten Fehler den kompletten Baum
 * ab – sichtbar bleibt dann nur der Seitenhintergrund. Genau so sah der Fehler
 * aus, bei dem `@sdc/auth` die Env-Vars nicht finden konnte.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { message: null };

  static getDerivedStateFromError(error: unknown): State {
    return { message: error instanceof Error ? error.message : String(error) };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[sdc-hub] Unbehandelter Fehler:', error, info.componentStack);
  }

  override render(): ReactNode {
    const { message } = this.state;
    if (!message) return this.props.children;

    return (
      <div className="login">
        <div className="login__card">
          <div className="login__brand">
            <span className="brand__dot" aria-hidden="true" />
            SDC&nbsp;Hub
          </div>
          <h1>Da ist etwas schiefgelaufen</h1>
          <div className="alert alert--error" role="alert">
            {message}
          </div>
          <p className="card__meta">
            Bitte diese Meldung weitergeben – damit ist die Ursache eindeutig.
          </p>
          <button
            type="button"
            className="px-btn px-btn--block"
            onClick={() => window.location.reload()}
          >
            Neu laden
          </button>
        </div>
      </div>
    );
  }
}
